import { configContentHub, configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  Ads,
  AnchorBlock,
  LatestArticle,
  Typography,
} from "@sphtech/dmg-design-system";
import { ContentHubData } from "@src/app/types/ServerCustomContext";
import cx from "classnames";

import styles from "./TechshowPortal.module.css";
type Props = {
  data: Omit<ContentHubData, "metaData">;
  from?: number;
  limit?: number;
};

export default function TechshowPortalBlock({
  data,
  from = 0,
  limit = 7,
}: Props) {
  const topStories = data.topStories && data.topStories.slice(from, limit);
  if (!topStories?.[0]) {
    return null;
  }
  const topStoriesHeader = data.displaySetting?.displayHeadline;
  const { Heading } = Typography;

  return (
    <section className={cx(styles.bodyContainer, styles.techshowLatestStories)}>
      {topStoriesHeader && (
        <div className={styles.latestArticleHeader}>
          <Heading.SubHeading2>{topStoriesHeader}</Heading.SubHeading2>
        </div>
      )}
      <div className={styles.latestArticleContainer}>
        <div className={styles.latestArticleLayout}>
          <AnchorBlock
            {...topStories[0]}
            displayPublishDate={configTeaser.publishDate}
            mobileCrop={configTeaser.anchorBlock?.mobileCrop}
            displayType={
              configContentHub.configTopStories?.anchorBlockDisplayType
            }
            aspectRatio={
              configContentHub.configTopStories?.anchorBlockAspectRatio
            }
            placeholder={placeholders.landscape}
          />
        </div>
      </div>

      <div
        className={cx(styles.gutterHorizontal, styles.contentBlockContainer)}
      >
        <div className={styles.contentBlockLayout}>
          {topStories.slice(1).map((teaser, index: number) => (
            <div key={index} className={styles.contentBlockItem}>
              <LatestArticle
                key={index}
                {...teaser}
                mode="landscape"
                displayPublishDate={configTeaser.publishDate}
                placeholders={placeholders}
                dateAfter={configTeaser.dateAfter}
              />
            </div>
          ))}
        </div>
        <div className={styles.sidebar}>
          <Ads.AdsSideBarDesktop />
        </div>
      </div>
    </section>
  );
}
